import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import CustomDivider from "../../Utils/CustomDivider/CustomDivider";
import Select from "react-select";
import { Editor } from "@tinymce/tinymce-react";
import CustomButton from "../../Utils/CustomButton/CustomButton";
import axiosInstance from "../../Service/BaseService.ts";
import getSurvice from "../../Service/test/test.ts";
import { CreateRequestPostModel } from "../../Models/CreateRequest/CreateRequestPost.ts";
import { MainContext } from "../../Context/MainContext/MainContext";

function CreateRequestScreen() {
  const { requestSubjectList, requestSubjectListFunction } = MainContext();
  const discriptionRef = useRef(null);
  const [option, SetOption] = useState(null);
  const [title, setTitle] = useState(null);
  const [selectSubjectTitle, setSelectSubjectTitle] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState([]);
  const [fileInfos, setFileInfos] = useState([]);

  useEffect(() => {
    requestSubjectListFunction();
    return;
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSelectSubjectTitle([]);
    if (requestSubjectList?.length >= 0)
      requestSubjectList.map((elem) => {
        setSelectSubjectTitle((oldArray) => [
          ...oldArray,
          {
            value: elem.id,
            label: elem.title,
            corresponding_role_id: elem.corresponding_role_id,
            status: elem.status,
          },
        ]);
        return 0;
      });
    return;
    // eslint-disable-next-line
  }, [requestSubjectList]);

  //************************************************* */
  const handleFileUpload = (event) => {
    event.preventDefault();

    const formData = new FormData();

    selectedFiles.forEach((file) => formData.append("files", file));

    axiosInstance
      .post("utils/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress((prevProgress) => {
            return prevProgress.map((file, index) => {
              if (index === progressEvent.config.data.fileIndex) {
                return { ...file, progress: percentCompleted };
              } else {
                return file;
              }
            });
          });
        },
      })
      .then((response) => console.log(response.data))
      .catch((error) => console.log(error));
  };

  const handleFileSectionForm = (event) => {
    handleFileSelection(event.target.files);
  };

  const handleFileSelection = (file) => {
    const files = file;
    setSelectedFiles(files);
    setUploadProgress(Array(files?.length).fill(0));

    for (let i = 0; i < files?.length; i++) {
      const file = files[i];
      const name = file.name;
      const size = file.size;
      const type = file.type.split("/")[1];

      fileInfos.push({ Name: name, Size: size, Type: type });
    }

    setFileInfos(fileInfos);
  };

  const [dragActive, setDragActive] = React.useState(false);
  const inputRef = React.useRef(null);

  function handleDrag(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  }

  function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFileSelection(e.dataTransfer.files);
    }
  }

  function onButtonClick() {
    inputRef.current.click();
  }
  //************************************************* */

  return (
    <Container>
      <TitleElement>
        <ImgContainer>
          <TitleIcon src="/Assets/Images/MakeReq.svg"></TitleIcon>
        </ImgContainer>
        <TitleText>ایجاد درخواست</TitleText>
      </TitleElement>
      <CustomDivider></CustomDivider>
      <BottomElement>
        <InputContainerRight>
          <InputInnerElement>
            <StyledContainer>
              <StyledLabel>عنوان درخواست :</StyledLabel>
              <Select
                options={selectSubjectTitle}
                isRtl
                isSearchable
                onChange={(value1) => {
                  setTitle(value1);
                }}
                placeholder={"انتخاب کنید..."}
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    width: Theme.inputWidth,
                    borderRadius: Theme.borderRadius,
                    height: Theme.inputHeight,
                  }),
                }}
              />
            </StyledContainer>
            <StyledContainer>
              <StyledLabel>گیرنده درخواست :</StyledLabel>
              <Select
                // options={options}
                isRtl
                isSearchable
                onChange={(value1) => {
                  SetOption(value1);
                }}
                placeholder={"انتخاب کنید..."}
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    width: Theme.inputWidth,
                    borderRadius: Theme.borderRadius,
                    height: Theme.inputHeight,
                  }),
                }}
              />
            </StyledContainer>
          </InputInnerElement>
          <EditorElement>
            <Editor
              apiKey="89ssbmd9mgedcbvwx4o44k19znwa7j1h8f9qrmrut6948k3v"
              onInit={(evt, editor) => (discriptionRef.current = editor)}
              initialValue=""
              init={{
                width: "100%",
                height: 400,
                max_height: 400,
                menubar: false,
                branding: false,
                language: "fa",
                color_map_background: Theme.colorBackgroundPage,
                color_default_background: Theme.colorBackgroundPage,
                plugins: [
                  "advlist",
                  "autolink",
                  "lists",
                  "link",
                  "image",
                  "emoticons",
                  "charmap",
                  "preview",
                  "anchor",
                  "searchreplace",
                  "visualblocks",
                  "code",
                  "fullscreen",
                  "insertdatetime",
                  "media",
                  "table",
                  "code",
                  "help",
                  "wordcount",
                ],
                toolbar:
                  "undo redo | blocks | " +
                  "| emoticons |" +
                  "bold italic forecolor | alignleft aligncenter " +
                  "alignright alignjustify | bullist numlist outdent indent | " +
                  "removeformat",

                content_style: "",
              }}
            />
          </EditorElement>
        </InputContainerRight>
        <FileUploaderContainerLeft>
          <Row>
            <StyledLabel>بارگزاری فایل :</StyledLabel>
          </Row>
          <Form
            onDragEnter={handleDrag}
            onSubmit={handleFileUpload}
            onClick={onButtonClick}
          >
            <InputFile
              ref={inputRef}
              type="file"
              multiple={false}
              onChange={handleFileSectionForm}
            />
            <LabelFile
              htmlFor={InputFile}
              className={dragActive ? "drag-active" : ""}
            >
              <ImgUpload src="/Assets/Images/UploadIcon.svg"></ImgUpload>
              <TextUpload>
                <TextLowColor> فایل ها را در اینجا رها کنید یا</TextLowColor>
                <ButtonText>کلیک کنید</ButtonText>
              </TextUpload>
              <LimitText>حداکثر حجم هر فایل 5MB می باشد</LimitText>
            </LabelFile>
            {dragActive && (
              <DropFile
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
              ></DropFile>
            )}
          </Form>
          <ShowDownloadContainer>
            {fileInfos.map((file, index) => (
              <UploadContainer>
                <UploadNameContainer>
                  <UploadRowText>
                    <UploadNameText>{fileInfos[index].Name}</UploadNameText>
                    <UploadSizeText>
                      ({fileInfos[index].Size / 1000000 + " MB"})
                    </UploadSizeText>
                  </UploadRowText>
                  <UploadRowProgress>
                    <UploadPersent>{uploadProgress[index]}%</UploadPersent>
                    <UploadProgress
                      value={uploadProgress[index]}
                      max="100"
                    ></UploadProgress>
                  </UploadRowProgress>
                </UploadNameContainer>
                <UploadInnerIconContainer>
                  <UploadInnerIconImg src="/Assets/Images/UploadInnerIcon.svg"></UploadInnerIconImg>
                </UploadInnerIconContainer>
              </UploadContainer>
            ))}
          </ShowDownloadContainer>
          <ButtonRowContainer>
            <CustomButton
              Label={"ارسال درخواست"}
              Width={"200px"}
              OnClick={async () => {
                // var req = new CreateRequestPostModel(
                //   0,
                //   1402,
                //   1,
                //   2,
                //   "dw",
                //   "ada"
                // );
                // await getSurvice(req);
                // if (discriptionRef.current) {
                //   console.log(discriptionRef.current.getContent());
                // }
              }}
            ></CustomButton>
          </ButtonRowContainer>
        </FileUploaderContainerLeft>
      </BottomElement>
    </Container>
  );
}

export default CreateRequestScreen;

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  direction: rtl;
  box-sizing: border-box;
  padding: 5px;
`;

const BottomElement = styled.div`
  width: 100%;
  height: 700px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const TitleElement = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const ImgContainer = styled.div`
  width: 38px;
  height: 38px;
  border: 1px solid #f5f7f8;
  background-color: transparent;
  border-radius: ${Theme.borderRadius};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TitleIcon = styled.img`
  object-fit: contain;
`;

const TitleText = styled.p`
  height: 40px;
  font-size: ${Theme.fontTitleSize};
  font-weight: ${Theme.fontInfoWeight};
  line-height: 41px;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const InputContainerRight = styled.div`
  width: 55%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-block: 20px;
`;

const FileUploaderContainerLeft = styled.div`
  width: 45%;
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const InputInnerElement = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
`;

const StyledContainer = styled.div`
  width: ${Theme.inputWidth};
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const StyledLabel = styled.p`
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontWeight};
  color: ${Theme.colorFontBlack};
  line-height: 5px;
`;

const EditorElement = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;
  margin-top: 50px;
`;

const Form = styled.form`
  height: 300px;
  width: 80%;
  max-width: 100%;
  text-align: center;
  position: relative;
`;

const InputFile = styled.input`
  display: none;
`;

const LabelFile = styled.label`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-radius: ${Theme.borderRadius};
  border-style: dashed;
  border-color: #cbd5e1;
  background-color: transparent;

  .drag-active {
    background-color: ${Theme.colorBackgroundPage};
  }
`;

const TextLowColor = styled.p`
  color: ${Theme.colorFontLabel};
  font-weight: ${Theme.fontWeight};
  margin-left: 4px;
`;

const LimitText = styled.p`
  color: ${Theme.colorFontLabel};
  font-size: ${Theme.fontSize};
  font-weight: ${Theme.fontWeight};
`;

const ButtonText = styled.p`
  color: ${Theme.colorFontBlack};
  font-weight: ${Theme.fontWeight};
`;

const TextUpload = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const DropFile = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

const ImgUpload = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
`;

const ShowDownloadContainer = styled.div`
  width: 100%;
  height: 220px;
  background-color: transparent;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const ButtonRowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  padding-inline: 70px;
`;

const Row = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const UploadContainer = styled.div`
  width: 80%;
  height: 70px;
  border-radius: ${Theme.borderRadius};
  background-color: transparent;
  border: 1px solid ${Theme.colorBorderTextField};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-block: 5px;
`;

const UploadNameContainer = styled.div`
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-end;
  margin-top: 15px;
`;

const UploadPersent = styled.p`
  width: 10px;
  height: 5px;
  text-align: center;
  font-size: 10px;
  line-height: 2px;
`;

const UploadProgress = styled.progress`
  width: 80%;
  height: 10px;
`;

const UploadInnerIconContainer = styled.div`
  width: 60px;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #b8bbf8;
  border-radius: ${Theme.borderRadius};
`;

const UploadInnerIconImg = styled.img`
  width: 20;
  height: 20;
  object-fit: contain;
`;

const UploadRowProgress = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
`;

const UploadRowText = styled.div`
  width: 60%;
  height: 6px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-evenly;
  align-items: center;
`;

const UploadNameText = styled.p`
  font-size: ${Theme.fontSize};
  font-weight: ${Theme.fontWeight};
  color: ${Theme.colorFontBlack};
`;

const UploadSizeText = styled.p`
  font-size: ${Theme.fontSize};
  font-weight: ${Theme.fontWeight};
  color: ${Theme.colorFontLabel};
`;
